module.exports = __webpack_public_path__ + "media/images/lp_02-705fba3d414257832d97268b537c7c4a.webp";